/**
 * @returns {number} Progress (1.0-100.0), but smart: It shows tiny progress as 1% and caps high progress at 100%.
 */
export const smartProgressPercentage = (receivedAmount: number, goalAmount: number): number => {
  let percent = (receivedAmount / goalAmount) * 100

  if (percent > 0.0 && percent < 1.0) percent = 1.0
  else if (percent > 100.0) percent = 100.0

  return percent
}

/**
 * @returns {number} Rounded progress (1-100) to show users (but without the %-sign).
 */
export const displayPercentage = (percent: number): number => {
  return Math.round(percent)
}
